<div>
<div class="emi-calculation-title">Loan Details</div>
<div class="emi-scroll">
<fpx-ro-grid [columnsArray]="columnsArray" 
  [tableDatafn]="gridService" 
  [title]="title"
  (handleActions)="handleActions($event)" 
  [gridWidth]="_gridWidth"
  [ngTemplateName]="'emiCalculationDisplayGrid'"
  [refreshGrid$]="refresh$"
  >
 
</fpx-ro-grid>
</div>
</div>

